import { ReactElement, useState } from 'react';
import { useWebSocket } from 'helpers/wsConnection';
import { useTranslation } from 'react-i18next';

interface EnvironmentTemperatureItemProps {
  deviceCode: string;
  selfReference: boolean;
  temperatureKey?: string;
}

export function EnvironmentTemperatureItem({
  deviceCode,
  selfReference,
  temperatureKey,
}: Readonly<EnvironmentTemperatureItemProps>): ReactElement {
  const { t } = useTranslation();

  const [temperature, setTemperature] = useState<number>();

  function onWsOpen(wsConn): void {
    if (selfReference && deviceCode.startsWith('DAM')) {
      wsConn.send({ type: 'subscribeStatus', data: { dam_Id: deviceCode } });
    } else {
      wsConn.send({ type: 'dutSubscribeRealTime', data: { DUT_ID: deviceCode } });
    }
  }

  function onWsMessage(payload): void {
    if (payload.data.dev_id !== deviceCode) return;
    if (payload.type === 'dutTelemetry') {
      setTemperature(payload.data.Temperature);
    }
    if (payload.type === 'damStatus') {
      setTemperature(payload.data[temperatureKey ?? 'Temperature']);
    }
  }

  function beforeWsClose(wsConn): void {
    wsConn.send({ type: 'unsubscribeStatus' });
    wsConn.send({ type: 'dutUnsubscribeRealTime' });
  }

  useWebSocket(onWsOpen, onWsMessage, beforeWsClose);

  return (
    <li>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <p>{t('temperaturaDoAmbiente')}</p>
        <div style={{
          marginLeft: 'auto', display: 'flex', gap: '8px', justifySelf: 'self-end',
        }}
        >
          <span>{`${temperature ?? '-'}°C`}</span>
        </div>
      </div>
    </li>
  );
}
